import { CloudRain, Flame, Waves } from "lucide-react";

const iconFor = (type) =>
  type === "API" ? <Flame size={15} /> : type === "ROB" ? <Waves size={15} /> : <CloudRain size={15} />;

const riskClass = (r) =>
  r === "TINGGI" ? "risk-high" : r === "WASPADA" ? "risk-watch" : "risk-safe";

export default function AlertList({ alerts }) {
  return (
    <div data-testid="alert-list">
      {alerts.map((alert) => (
        <div
          className="alert-row"
          key={alert.id}
          data-testid={`alert-${alert.type.toLowerCase()}`}
        >
          <div className={`alert-icon ${alert.type.toLowerCase()}`}>
            {iconFor(alert.type)}
          </div>
          <div>
            <b>{alert.title}</b>
            <span>
              {alert.district} · {alert.detail}
            </span>
          </div>
          <strong className={riskClass(alert.level)}>{alert.level}</strong>
        </div>
      ))}
    </div>
  );
}
